import Component from "./input_v2"
export default Component;